import { Button } from '@next-nx/shared-ui/atoms'
import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import styles from './LandingCta.module.sass'


interface Props {
  item: MenuItemType | undefined
  onClick: () => void
  className?: string
}

const LandingCta = (props: Props) => {

  const { 
    item = undefined,
    onClick = undefined,
    className = '',
  } = props

  const { linkDataLayer } = useTealium()

  const handleTracking = () => {
    const action_timestamp = getTimestamp()
  
    linkDataLayer({
       virtual: "action",
       action_name: "richiesta_preventivo", 
       action_tech: "click",
       action_type: "richiedi_preventivo",
       action_timestamp,
       action_effect: "form_richiesta_preventivo_accesso"
    });
  }

  return item ? (
    <div className={`${styles.landingCta} ${className}`}>
      <p className={styles.title}>{item.name}</p>
      {item.ctaLabel && onClick && (
        <div className={styles.ctaBox}>
          <Button label={item.ctaLabel} onClick={() => {
            onClick()
            handleTracking()
            }} />
        </div>
      )}
    </div>
  ) : <></>
}

export default LandingCta
